<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddReason"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">{{ action }} employee</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="p-4">
            <label>Reason</label>
            <textarea
              @change="(e) => getReason(e.target.value)"
              class="p-1 my-1 bg-gray-200 rounded-xl w-full"
              cols="5"
              rows="5"
              required
            ></textarea>
          </div>
          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
              @click="setIsConfirmed(action.trim().toUpperCase())"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      >
    </transition>
  </div>
</template>

<script>
export default {
  name: "AddEmployeeEditReason",
  props: ["showAddReason", "action", "getReason", "setIsConfirmed"],

  data() {
    return {
      selectedType: "single",
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
